import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const NotFoundPage = () => {
  const { user } = useAuth();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Stack spacing={2} alignItems="center" textAlign="center" sx={{ maxWidth: 480 }}>
        <Typography variant="h2" sx={{ fontWeight: 700, lineHeight: 1 }}>
          404
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary">
          The page does not exist or you do not have permission to access it.
        </Typography>
        <Stack direction="row" spacing={1}>
          {user ? (
            <Button component={RouterLink} to="/" variant="contained">
              Go to Dashboard
            </Button>
          ) : (
            <Button component={RouterLink} to="/login" variant="contained">
              Go to Login
            </Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default NotFoundPage;
